import { Checkbox, FormControlLabel } from "@mui/material";
import { SmallBody } from "helpers/TypographyComponents";
import { useEffect, useState } from "react";

interface IMarkAsCheckbox {
    checked: boolean;
    handleChange: (checked: boolean) => void;
    /**
     * Color when checked
     */
    activeColor?: "info" | "success";
    label: string;
    /**
     * Label when checked
     */
    checkedLabel?: string;
    disabled?: boolean;
}
/**
 * Mark as checkbox. Used for single actions like "Mark beneficiary profile as completed"
 */
const MarkAsCheckbox = ({
    checked,
    handleChange,
    activeColor = "info",
    label,
    checkedLabel,
    disabled = false,
}: IMarkAsCheckbox) => {
    const [localChecked, setLocalChecked] = useState(checked);
    const [localCheckedLabel, setLocalCheckedLabel] = useState(checkedLabel ?? label);

    const color = {
        info: "#275ab0",
        success: "#267847",
    };

    const handleCheck = (e: any) => {
        const { checked } = e.target;
        setLocalChecked(checked);
        setLocalCheckedLabel(checkedLabel ?? label);
        handleChange(checked);
    };

    useEffect(() => {
        setLocalChecked(checked);
    }, [checked]);

    return (
        <FormControlLabel
            control={
                <Checkbox
                    checked={localChecked}
                    onChange={handleCheck}
                    sx={{
                        padding: "12px",
                        width: "16px",
                        height: "16px",
                        color: localChecked ? color[activeColor] : "#646464",
                        "& .MuiSvgIcon-root": {
                            fontSize: "16px",
                        },
                    }}
                    disabled={disabled}
                />
            }
            label={
                <SmallBody color={localChecked ? activeColor : "grey"}>
                    {localChecked ? localCheckedLabel : label}
                </SmallBody>
            }
            sx={{
                marginInline: "0",
                cursor: disabled ? "not-allowed !important" : "pointer !important",
            }}
        />
    );
};

export default MarkAsCheckbox;
